import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import getConfig from 'next/config';

const { BASE_URL_TANYA } = getConfig().publicRuntimeConfig;

import styles from './PostReviewer.module.scss';

interface PostReviewerProps {
  reviewers: string;
}

const PostReviewer = (props: PostReviewerProps) => {
  const { reviewers } = props;
  const reviewer = JSON.parse(reviewers);
  const baseURLTanya = BASE_URL_TANYA || 'https://lifepal.co.id/tanya/';

  return (
    <div className={styles['post-reviewer']}>
      <span>Telah Ditinjau: </span>
      <div className={styles['post-reviewer__avatar']}>
        <Image
          src={reviewer.avatar}
          alt={reviewer.name}
          width={32}
          height={32}
          loading="lazy"
          priority={false}
          quality={60}
        />
      </div>
      <Link href={`${baseURLTanya}questions/profile/${reviewer.slug}`}>{reviewer.name}</Link>
    </div>
  );
};

export default PostReviewer;
